import React from "react";
import Sidebar from "../components/Sidebar"; // Import the Sidebar component
import { Outlet } from "react-router-dom";

const PatientDashboard = () => {
  // Sidebar items
  const items = [
    { name: "Dashboard", link: "/patient", icon: "🏠" },
    { name: "Medical Reports", link: "/patient/Patient-Report", icon: "👤" },
    
  ];

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <Sidebar items={items} />
      {/* Main Content */}
      <div style={{ flex: 1, padding: "20px" }}>
        <h1>Patient Dashboard</h1>
        {/* Outlet for nested routes */}
        <Outlet />
      </div>
    </div>
  );
};

export default PatientDashboard;
